import { Object3D } from 'three'

import * as Util from './util'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

export default class SimpleModel extends Object3D {
  constructor(asset, factory = null) {
    super()
    this._asset = asset
    this._onLoadModel = () => {}
    this._loader = new GLTFLoader()
    this._parentName = null
    this._modelFactory = factory
    this._animationRunning = false

    if (asset) {
      this.load(asset)
    }
  }

  setCurrentAnimation(animation) {
    this._animationRunning = animation
  }

  set setParentName(name) {
    this._parentName = name
  }

  set onLoadModel(callback) {
    this._onLoadModel = callback
  }

  get getParentName() {
    return this._parentName
  }

  load(url) {
    if (this._modelFactory != null) {
      this._modelFactory.loadModel(url).then((model) => {
        let actualModel = null
        if (this._animationRunning) {
          actualModel = Util.deepClone(model)
        } else {
          actualModel = model
        }
        this.traverse((node) => {
          this.remove(node)
        })
        Util.applyShadowOnModel(actualModel)
        this.add(actualModel)
        this._onLoadModel(actualModel)
      })
    } else {
      Util.loadModel(this._loader, url).then((gltf) => {
        let model = gltf.scene
        this.traverse((node) => {
          this.remove(node)
        })
        Util.applyShadowOnModel(model)
        this.add(model)
        this._onLoadModel(model)
      })
    }
  }
}
